"use client";

interface ToolbarProps {
  onInsert: (before: string, after?: string) => void;
}

const buttonGroups = [
  [
    { label: "B", title: "Bold", before: "**", after: "**" },
    { label: "I", title: "Italic", before: "_", after: "_" },
  ],
  [
    { label: "H1", title: "Heading 1", before: "# " },
    { label: "H2", title: "Heading 2", before: "## " },
    { label: "H3", title: "Heading 3", before: "### " },
  ],
  [
    { label: "Link", title: "Link", before: "[", after: "](url)" },
    { label: "Img", title: "Image", before: "![alt](", after: ")" },
  ],
  [
    { label: "UL", title: "Unordered List", before: "- " },
    { label: "OL", title: "Ordered List", before: "1. " },
  ],
  [
    { label: "Code", title: "Inline Code", before: "`", after: "`" },
    { label: "Block", title: "Code Block", before: "```\n", after: "\n```" },
    { label: "Quote", title: "Blockquote", before: "> " },
  ],
];

export default function Toolbar({ onInsert }: ToolbarProps) {
  return (
    <div className="flex flex-wrap items-center gap-1 px-4 py-1.5 border-b border-border bg-background">
      {buttonGroups.map((group, gi) => (
        <div key={gi} className="flex items-center">
          {gi > 0 && (
            <div className="w-px h-4 bg-border mx-1" />
          )}
          <div className="flex gap-0.5">
            {group.map((btn) => (
              <button
                key={btn.title}
                title={btn.title}
                onClick={() => onInsert(btn.before, btn.after)}
                className="px-2 py-1 rounded text-sm text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
